import React from "react";
import { connect } from "react-redux";
import Card from "components/card";
import AccessButton from "components/button/accessbutton";
import {
    FileText,
} from "lucide-react"
import EmployeeDocumentsTabs from "./DocumentsTab";

const EmployeeDocuments = ({
}) => {

    return (
        <div className="flex flex-col space-y-6">
            <AccessButton
                backLabel="Back to Employee Details"
                withBack={true}
                baseRoute="/console/employee-details"
            />
            <>
                <div className="space-y-6">
                    <Card className="flex flex-col gap-6 rounded-xl border border-emerald-200 bg-gradient-to-br from-white to-emerald-50/30">
                        <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 
                                        grid-cols-[1fr_auto] [.border-b]:pb-6"
                        >
                            <div className="flex items-center gap-3">
                                <div className="p-3 rounded-lg bg-emerald-100">
                                    <FileText className="w-6 h-6 text-emerald-600" />
                                </div>
                                <div>
                                    <h4 className="text-[18px]">Employee Documents & Contracts</h4>
                                    <p className="text-slate-700">
                                        All documents for Ashley Palma (EMP001)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Card>
                    <div className="flex flex-col gap-2 w-full">
                        <EmployeeDocumentsTabs />
                    </div>
                </div>
            </>
        </div>
    );
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDocuments);